var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography, FormControl, InputLabel, Select, MenuItem, TextField, FormHelperText, } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { format, isValid, isBefore } from 'date-fns';
import DownloadButton from '../../../molecules/DownloadButton';
var TaxReturns = function () {
    var t = useTranslation().t;
    var offices = [
        { code: 'Bv', name: 'Bv' },
        { code: 'Tw', name: 'Taiwan' },
        { code: 'Kr', name: 'Korea' },
    ];
    var _a = useState(''), selectedOffice = _a[0], setSelectedOffice = _a[1];
    var _b = useState(null), fromDate = _b[0], setFromDate = _b[1];
    var _c = useState(null), toDate = _c[0], setToDate = _c[1];
    var _d = useState(''), fromDateError = _d[0], setFromDateError = _d[1];
    var _e = useState(''), toDateError = _e[0], setToDateError = _e[1];
    var formatDateForApi = function (date) {
        if (!date || !isValid(date))
            return '';
        return format(date, 'yyyy-MM-dd');
    };
    // 拠点名を英語表記に変換
    var getOfficeEnglishName = function (officeCode) {
        var office = offices.find(function (o) { return o.code === officeCode; });
        return office ? office.name : officeCode;
    };
    // 日付バリデーション
    var validateFromDate = function (date) {
        if (!date) {
            setFromDateError('');
            return;
        }
        if (!isValid(date)) {
            setFromDateError(t('admin.exportCsv.errors.invalidDateFormat'));
            return;
        }
        setFromDateError('');
    };
    var validateToDate = function (date) {
        if (!date) {
            setToDateError('');
            return;
        }
        if (!isValid(date)) {
            setToDateError(t('admin.exportCsv.errors.invalidDateFormat'));
            return;
        }
        if (fromDate && isBefore(date, fromDate)) {
            setToDateError(t('admin.exportCsv.errors.toDateBeforeFromDate'));
            return;
        }
        setToDateError('');
    };
    var handleFromDateChange = function (newValue) {
        setFromDate(newValue);
        validateFromDate(newValue);
        // 終了日も再検証
        if (toDate) {
            validateToDate(toDate);
        }
    };
    var handleToDateChange = function (newValue) {
        setToDate(newValue);
        validateToDate(newValue);
    };
    // ダウンロードボタンの活性化条件
    var isDownloadEnabled = selectedOffice && fromDate && toDate && !fromDateError && !toDateError;
    return (React.createElement(Grid, { container: true, spacing: 3 },
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Typography, { variant: "h2", component: "h2", gutterBottom: true }, t('admin.exportCsv.taxReturns.title'))),
        React.createElement(Grid, { item: true, xs: 12, md: 4 },
            React.createElement(FormControl, { fullWidth: true },
                React.createElement(InputLabel, { id: "office-select-label" }, t('admin.exportCsv.labels.officeLabel')),
                React.createElement(Select, { labelId: "office-select-label", value: selectedOffice, onChange: function (e) { return setSelectedOffice(e.target.value); }, label: t('admin.exportCsv.labels.officeLabel') }, offices.map(function (office) { return (React.createElement(MenuItem, { key: office.code, value: office.code }, office.name)); })))),
        React.createElement(Grid, { item: true, xs: 12, md: 4 },
            React.createElement(FormControl, { fullWidth: true, error: !!fromDateError },
                React.createElement(DatePicker, { label: t('admin.exportCsv.labels.fromDateLabel'), value: fromDate, onChange: handleFromDateChange, renderInput: function (params) { return React.createElement(TextField, __assign({}, params, { fullWidth: true })); } }),
                fromDateError && React.createElement(FormHelperText, null, fromDateError))),
        React.createElement(Grid, { item: true, xs: 12, md: 4 },
            React.createElement(FormControl, { fullWidth: true, error: !!toDateError },
                React.createElement(DatePicker, { label: t('admin.exportCsv.labels.toDateLabel'), value: toDate, onChange: handleToDateChange, renderInput: function (params) { return React.createElement(TextField, __assign({}, params, { fullWidth: true })); } }),
                toDateError && React.createElement(FormHelperText, null, toDateError))),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(DownloadButton, { title: t('admin.exportCsv.labels.downloadButton'), path: "/api/admin/export_csv/tax_returns", downloadFilename: "tax_returns_".concat(getOfficeEnglishName(selectedOffice), "_").concat(fromDate && isValid(fromDate) ? format(fromDate, 'yyyyMMdd') : '', "_").concat(toDate && isValid(toDate) ? format(toDate, 'yyyyMMdd') : '', ".csv"), params: {
                    office_code: selectedOffice,
                    from_date: formatDateForApi(fromDate),
                    to_date: formatDateForApi(toDate),
                }, size: "medium", disabled: !isDownloadEnabled }))));
};
export default TaxReturns;
